/**
 * Extract box/product IDs from the Orders sheet "Items" cell text
 * (e.g. "Name (ID: HOM010) × 1 | ...").
 */
export function parseProductIdsFromOrderItems(itemsStr) {
  const s = String(itemsStr || "");
  const seen = new Set();
  const re = /\(ID:\s*([^)]+?)\)/gi;
  let m;
  while ((m = re.exec(s)) !== null) {
    const chunk = m[1].trim();
    chunk.split(/\s*\/\s*/).forEach((part) => {
      const id = part.trim();
      if (id.length > 0 && id.length < 80) seen.add(id);
    });
  }
  return Array.from(seen);
}
